module.exports = __webpack_public_path__ + "static/media/worker.c9975ced.svg";